/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createHiddenPasswordStyle = makeStyles(() => ({
  container: {
    alignItems: 'center',
  },
  visibilityIcon: {
    padding: '0',
    margin: '0 24px 0 10px',
  },
  copyIcon: {
    padding: '0',
    margin: '0 0 0 10px',
  },
  link: {
    padding: 0,
    minWidth: '1px',
  },
  spinner: {
    minHeight: 'auto !important',
  },
}));

export { createHiddenPasswordStyle };
